export type SupportedCurrency = 'USD' | 'INR' | 'CAD' | 'SGD';

type CurrencyConfig = {
  code: SupportedCurrency;
  locale: string;
  symbol: string;
};

const CURRENCY_CONFIG: Record<SupportedCurrency, CurrencyConfig> = {
  USD: { code: 'USD', locale: 'en-US', symbol: '$' },
  INR: { code: 'INR', locale: 'en-IN', symbol: '₹' },
  CAD: { code: 'CAD', locale: 'en-US', symbol: 'CA$' },
  SGD: { code: 'SGD', symbol: 'S$', locale: 'en-US' },
};

export const DEFAULT_CURRENCY: SupportedCurrency = 'USD';

export function normalizeCurrency(value?: string | null): SupportedCurrency {
  if (!value) return DEFAULT_CURRENCY;
  const normalized = value.toUpperCase() as SupportedCurrency;
  return CURRENCY_CONFIG[normalized] ? normalized : DEFAULT_CURRENCY;
}

export function formatMoney(amount: number, value?: string | null): string {
  const currency = normalizeCurrency(value);
  return new Intl.NumberFormat(CURRENCY_CONFIG[currency].locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount || 0));
}

export function getCurrencySymbol(value?: string | null): string {
  const currency = normalizeCurrency(value);
  return CURRENCY_CONFIG[currency].symbol;
}
